<template>
  <div>
    <p class="text-xs-center">#{{event.event_no}} {{event.gender}} {{event.agegroup}} {{event.distance}} {{event.stroke}}</p>
    <v-data-table :headers="headers" :items="results"
       class="elevation-1" :custom-sort="customSort" disable-initial-sort
       :rows-per-page-items='[{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1},5,10,25]'>
      <template v-slot:items="props">
        <tr>
          <router-link :to="`/athlete?date=${date}&team=${teams.join('&team=')}&athleteno=${props.item.ath_no}`"><td>{{ props.item.name }}</td></router-link>
          <td>{{ props.item.age }}</td>
          <td>{{ props.item.team }}</td>
          <td>{{ props.item.place }}</td>
          <td>{{ props.item.points }}</td>
          <td>{{ props.item.seed }}</td>
          <td>{{ props.item.finish }}</td>
          <td :style="{color: props.item.backgroundColor}">{{ props.item.delta }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  methods: {
    customSort(items, index, isDesc) {
      if(index===null) {
        return items;
      }
      items.sort((a, b) => {
        if (!isDesc) {
          return a[index] < b[index] ? -1 : 1;
        } else {
          return b[index] < a[index] ? -1 : 1;
        }
      });
      if(index==='place' || index===null) {
        return [].concat(...
          items.filter((el) => el.place!==0),
          items.filter((el) => el.place===0));
      }
      return items;
    },
    pad(n) {
      return `00${n}`.slice(-2);
    },
    seedTime({time}) {
      if (time === 0 || time === null) {
        return 'NT'
      } else {
        return time
      }
    },
    finishTime({time,stat}) {
      console.log({time,stat})
      if(stat.trim() === '') {
        return time
      } else if(stat === 'Q') {
        return 'DQ'
      }
      return 'NS'
    },
    getTime(t) {
      if (t === 'DQ' || t === 'NS') return t

      if(t > 60) {
        return `${Math.floor(t/60)}:${this.pad(Math.floor(t%60))}.${this.pad(Math.round((t%1)*100))}`;
      }
      return `${this.pad(Math.floor(t%60))}.${this.pad(Math.round((t%1)*100))}`;
    },
    delta({seed, finish}) {
      if (seed === 'NT' || finish === 'NS' || finish === 'DQ') {
        return 'NA'
      } else {
        return (finish - seed).toFixed(2)
      }
    },
    rowColor({delta}) {
      if (delta === "NA") return 'transparent'

      if (delta <= 0) {
        // return '#DFF9D1'
        return 'green'
      } else {
        // return '#F9D1DF'
        return 'red'
      }
    },
  },
  data: () => ({
    headers: [
      {text: "Name", value: "name", align: 'left', sortable: true},
      {text: "Age", value: "age", align: 'left', sortable: true},
      {text: "Team", value: "team", align: 'left', sortable: true},
      {text: "Place", value: "place", align: 'left', sortable: true},
      {text: "Points", value: "points", align: 'left', sortable: true},
      {text: "Seed", value: "seed", align: 'left', sortable: true},
      {text: "Finish", value: "finish", align: 'left', sortable: true},
      {text: "Change", value: "delta", align: "left", sortable: true}
    ],
    date: "1234",
    eventno: "",
    teams: [],
    event: {},
    results: []
  }),
  created() {
    this.eventno = this.$route.query.eventno;
    this.teams = this.$route.query.team;
    this.date = this.$route.query.date;
    this.$http.get(`${process.env.VUE_APP_API_URL}/event?date=${this.date}&eventno=${this.eventno}&team=${this.teams.join("&team=")}`)
      .then(function(data) {
        this.event = data.body.event[0];
        this.results = data.body.results.map(row => ({
          ath_no: row.ath_no,
          name: `${row.last_name}, ${row.first_name} ${row.initial}`,
          age: row.ath_age,
          team: row.team_abbr,
          place: row.fin_place === 0 && row.fin_stat.trim() === '' ? 'X' : row.fin_place,
          points: row.ev_score,
          seed: this.getTime(this.seedTime({time: row.actualseed_time})),
          finish: this.getTime(this.finishTime({time: row.fin_time, stat: row.fin_stat})),
          delta: this.delta({ seed: this.seedTime({time: row.actualseed_time}), finish: this.finishTime({time: row.fin_time, stat: row.fin_stat}) }),
          backgroundColor: this.rowColor({delta: this.delta({ seed: this.seedTime({time: row.actualseed_time}), finish: this.finishTime({time: row.fin_time, stat: row.fin_stat}) })})
        }));
      })
  }
}
</script>

<style>

</style>
